'use client'

import type { ReactNode } from 'react'

export function PageHeader({
  title,
  description,
  action,
  icon,
}: {
  title: string
  description?: string
  action?: ReactNode
  icon?: ReactNode
}) {
  return (
    <header className="h-[60px] px-6 flex items-center justify-between border-b border-hair bg-page shrink-0">
      <div className="flex items-center gap-3 min-w-0">
        {icon ? <div className="shrink-0 text-accent flex items-center">{icon}</div> : null}
        <div className="flex flex-col gap-0.5 min-w-0">
          <h2 className="text-base font-medium text-ink truncate">{title}</h2>
          {description ? <p className="text-xs text-muted truncate">{description}</p> : null}
        </div>
      </div>
      {action ? <div className="flex items-center gap-2 shrink-0">{action}</div> : null}
    </header>
  )
}
